/**
 * WEB-2115 — режим «страница открыта по ссылке предпросмотра».
 *
 * Страница предпросмотра (`pages/PublicPreview.tsx`) кладёт сюда загрузчик
 * частей воронки (квиз / пейволл той же зафиксированной версии через
 * публичную дверь). Страницы квиза и пейволла, увидев загрузчик:
 *  - берут тело у него, а не у боевой выдачи и не у черновика автора;
 *  - снимают порог «на нашем домене воронки не показываются» — именованным
 *    исключением ровно для этого режима;
 *  - работают «не боевыми»: ни событий, ни пикселей, оплата отказывает с
 *    причиной `preview` (тот же признак, что у предпросмотра автора).
 *
 * Контекст, а не параметр адреса: включить режим подстановкой в ссылку на
 * боевую воронку нельзя по устройству, и встроенный пейволл после квиза
 * получает тот же загрузчик без проводки через визард.
 */
import { createContext, useContext } from 'react';

/**
 * Ответ той же формы, что у загрузчиков страниц
 * (`kind: 'ok' | 'not-found' | 'unavailable'`): страницы берут его как есть,
 * без перекладки — каждая строка в них едет покупателю в первом экране.
 * `unavailable` — временный сбой двери (сеть, 5xx, 429): у плеера на него
 * экран «временно недоступно» с кнопкой «Повторить», а не «не найдено».
 */
export type PreviewPartResult =
  | { kind: 'ok'; data: Record<string, unknown> }
  | { kind: 'not-found' }
  | { kind: 'unavailable' };

export type PreviewPartLoader = (
  part: 'quiz' | 'paywall',
) => Promise<PreviewPartResult>;

export const PreviewLinkModeContext = createContext<PreviewPartLoader | null>(
  null,
);

export function usePreviewLinkMode(): PreviewPartLoader | null {
  return useContext(PreviewLinkModeContext);
}
